/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MoneyCurrencyRubleCircleIcon16Light } from './MoneyCurrencyRubleCircleIcon16Light';
import { MoneyCurrencyRubleCircleIcon16Regular } from './MoneyCurrencyRubleCircleIcon16Regular';
import { MoneyCurrencyRubleCircleIcon16Solid } from './MoneyCurrencyRubleCircleIcon16Solid';
import { MoneyCurrencyRubleCircleIcon20Light } from './MoneyCurrencyRubleCircleIcon20Light';
import { MoneyCurrencyRubleCircleIcon20Regular } from './MoneyCurrencyRubleCircleIcon20Regular';
import { MoneyCurrencyRubleCircleIcon20Solid } from './MoneyCurrencyRubleCircleIcon20Solid';
import { MoneyCurrencyRubleCircleIcon24Regular } from './MoneyCurrencyRubleCircleIcon24Regular';
import { MoneyCurrencyRubleCircleIcon24Solid } from './MoneyCurrencyRubleCircleIcon24Solid';
import { MoneyCurrencyRubleCircleIcon32Regular } from './MoneyCurrencyRubleCircleIcon32Regular';
import { MoneyCurrencyRubleCircleIcon64Regular } from './MoneyCurrencyRubleCircleIcon64Regular';
var sizes = {
    16: {
        light: MoneyCurrencyRubleCircleIcon16Light,
        regular: MoneyCurrencyRubleCircleIcon16Regular,
        solid: MoneyCurrencyRubleCircleIcon16Solid,
    },
    20: {
        light: MoneyCurrencyRubleCircleIcon20Light,
        regular: MoneyCurrencyRubleCircleIcon20Regular,
        solid: MoneyCurrencyRubleCircleIcon20Solid,
    },
    24: {
        regular: MoneyCurrencyRubleCircleIcon24Regular,
        solid: MoneyCurrencyRubleCircleIcon24Solid,
    },
    32: {
        regular: MoneyCurrencyRubleCircleIcon32Regular,
    },
    64: {
        regular: MoneyCurrencyRubleCircleIcon64Regular,
    },
};
export var MoneyCurrencyRubleCircleIcon = forwardRef('MoneyCurrencyRubleCircleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
